export default __webpack_public_path__ + "379472bfcf8213d82f3e66633f2acfec.obj";